// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.capabilities_list__xlsEQ {
  display: grid;
  gap: clamp(3rem, 2rem + 5vw, 7rem);
}
.capabilities_block__UPHAk {
  display: grid;
  gap: var(--space-6);
  grid-template-columns: minmax(0, 1fr);
  align-items: center;
}
.capabilities_copy__2TtP4 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-4);
}
.capabilities_label__A6H2\\+ {
  margin: 0;
  display: flex;
  align-items: center;
  gap: var(--space-3);
  font-size: var(--text-eyebrow);
  letter-spacing: var(--tracking-eyebrow);
  text-transform: uppercase;
  font-weight: 700;
  color: var(--color-text-muted);
}
.capabilities_index__EeCg0 {
  color: var(--kur-amber);
  font-variant-numeric: tabular-nums;
}
.capabilities_title__qBJNE {
  margin: 0;
  font-size: var(--text-h2);
  line-height: var(--leading-heading);
  font-weight: 500;
  letter-spacing: var(--tracking-subheading);
  text-wrap: balance;
}
.capabilities_text__Pps\\+9 {
  margin: 0;
  max-width: 32rem;
  font-size: var(--text-body-lg);
  line-height: var(--leading-body);
  color: var(--color-text-muted);
}
.capabilities_points__RDal0 {
  margin: 0 0 var(--space-2);
  padding: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
}
.capabilities_points__RDal0 li {
  padding: 0.4rem 0.9rem;
  font-size: var(--text-caption);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-pill);
  color: var(--color-text);
}
.capabilities_media__trU1I {
  position: relative;
  aspect-ratio: 4 / 3;
  overflow: hidden;
  border-radius: 0 var(--radius-lg) 0 var(--radius-lg);
  background: var(--color-ink);
  display: grid;
  place-items: center;
}
.capabilities_media__trU1I::before {
  content: "";
  position: absolute;
  width: 62%;
  aspect-ratio: 1;
  right: -26%;
  bottom: -38%;
  border-radius: 50%;
  border: clamp(10px, 1.4vw, 18px) solid var(--kur-gold);
}
.capabilities_media__trU1I::after {
  content: "";
  position: absolute;
  width: 44%;
  aspect-ratio: 1;
  right: -16%;
  bottom: -28%;
  border-radius: 50%;
  background: var(--color-slate);
  opacity: 0.6;
}
.capabilities_icon__4oih6 {
  position: relative;
  z-index: 1;
  width: clamp(8rem, 5rem + 12vw, 15rem);
  margin: 0 12% 8% 0;
  height: auto;
  display: block;
}
.capabilities_bigIndex__KUqY7 {
  position: absolute;
  top: 1.25rem;
  left: 1.5rem;
  z-index: 1;
  font-size: clamp(1rem, 0.8rem + 0.6vw, 1.35rem);
  font-weight: 700;
  letter-spacing: 0.1em;
  color: var(--color-mist);
  font-variant-numeric: tabular-nums;
}
.capabilities_flip__\\+1E5v .capabilities_media__trU1I::before {
  right: auto;
  left: -26%;
}
.capabilities_flip__\\+1E5v .capabilities_media__trU1I::after {
  right: auto;
  left: -16%;
}
.capabilities_flip__\\+1E5v .capabilities_icon__4oih6 {
  margin: 0 0 8% 12%;
}

@media (min-width: 992px) {
  .capabilities_block__UPHAk {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1.1fr);
    gap: var(--space-8);
  }
  .capabilities_flip__\\+1E5v .capabilities_copy__2TtP4 {
    order: 2;
  }
  .capabilities_flip__\\+1E5v .capabilities_media__trU1I {
    border-radius: var(--radius-lg) 0 var(--radius-lg) 0;
  }
  .capabilities_media__trU1I {
    aspect-ratio: 5 / 4;
  }
}
`, "",{"version":3,"sources":["webpack://./src/PAGES/HOME_PAGE/SECTIONS/CAPABILITIES/capabilities.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,uCAAuC;EACvC,yBAAyB;EACzB,gBAAgB;EAChB,8BAA8B;AAChC;AACA;EACE,uBAAuB;EACvB,kCAAkC;AACpC;AACA;EACE,SAAS;EACT,yBAAyB;EACzB,mCAAmC;EACnC,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,8BAA8B;EAC9B,gCAAgC;EAChC,8BAA8B;AAChC;AACA;EACE,0BAA0B;EAC1B,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,qCAAqC;EACrC,iCAAiC;EACjC,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,oDAAoD;EACpD,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sDAAsD;AACxD;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,sCAAsC;EACtC,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,+CAA+C;EAC/C,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;EACxB,kCAAkC;AACpC;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,sDAAsD;IACtD,mBAAmB;EACrB;EACA;IACE,QAAQ;EACV;EACA;IACE,oDAAoD;EACtD;EACA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".list {\n  display: grid;\n  gap: clamp(3rem, 2rem + 5vw, 7rem);\n}\n.block {\n  display: grid;\n  gap: var(--space-6);\n  grid-template-columns: minmax(0, 1fr);\n  align-items: center;\n}\n.copy {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: var(--space-4);\n}\n.label {\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: var(--space-3);\n  font-size: var(--text-eyebrow);\n  letter-spacing: var(--tracking-eyebrow);\n  text-transform: uppercase;\n  font-weight: 700;\n  color: var(--color-text-muted);\n}\n.index {\n  color: var(--kur-amber);\n  font-variant-numeric: tabular-nums;\n}\n.title {\n  margin: 0;\n  font-size: var(--text-h2);\n  line-height: var(--leading-heading);\n  font-weight: 500;\n  letter-spacing: var(--tracking-subheading);\n  text-wrap: balance;\n}\n.text {\n  margin: 0;\n  max-width: 32rem;\n  font-size: var(--text-body-lg);\n  line-height: var(--leading-body);\n  color: var(--color-text-muted);\n}\n.points {\n  margin: 0 0 var(--space-2);\n  padding: 0;\n  list-style: none;\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--space-2);\n}\n.points li {\n  padding: 0.4rem 0.9rem;\n  font-size: var(--text-caption);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-pill);\n  color: var(--color-text);\n}\n.media {\n  position: relative;\n  aspect-ratio: 4 / 3;\n  overflow: hidden;\n  border-radius: 0 var(--radius-lg) 0 var(--radius-lg);\n  background: var(--color-ink);\n  display: grid;\n  place-items: center;\n}\n.media::before {\n  content: \"\";\n  position: absolute;\n  width: 62%;\n  aspect-ratio: 1;\n  right: -26%;\n  bottom: -38%;\n  border-radius: 50%;\n  border: clamp(10px, 1.4vw, 18px) solid var(--kur-gold);\n}\n.media::after {\n  content: \"\";\n  position: absolute;\n  width: 44%;\n  aspect-ratio: 1;\n  right: -16%;\n  bottom: -28%;\n  border-radius: 50%;\n  background: var(--color-slate);\n  opacity: 0.6;\n}\n.icon {\n  position: relative;\n  z-index: 1;\n  width: clamp(8rem, 5rem + 12vw, 15rem);\n  margin: 0 12% 8% 0;\n  height: auto;\n  display: block;\n}\n.bigIndex {\n  position: absolute;\n  top: 1.25rem;\n  left: 1.5rem;\n  z-index: 1;\n  font-size: clamp(1rem, 0.8rem + 0.6vw, 1.35rem);\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  color: var(--color-mist);\n  font-variant-numeric: tabular-nums;\n}\n.flip .media::before {\n  right: auto;\n  left: -26%;\n}\n.flip .media::after {\n  right: auto;\n  left: -16%;\n}\n.flip .icon {\n  margin: 0 0 8% 12%;\n}\n\n@media (min-width: 992px) {\n  .block {\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1.1fr);\n    gap: var(--space-8);\n  }\n  .flip .copy {\n    order: 2;\n  }\n  .flip .media {\n    border-radius: var(--radius-lg) 0 var(--radius-lg) 0;\n  }\n  .media {\n    aspect-ratio: 5 / 4;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": `capabilities_list__xlsEQ`,
	"block": `capabilities_block__UPHAk`,
	"copy": `capabilities_copy__2TtP4`,
	"label": `capabilities_label__A6H2+`,
	"index": `capabilities_index__EeCg0`,
	"title": `capabilities_title__qBJNE`,
	"text": `capabilities_text__Pps+9`,
	"points": `capabilities_points__RDal0`,
	"media": `capabilities_media__trU1I`,
	"icon": `capabilities_icon__4oih6`,
	"bigIndex": `capabilities_bigIndex__KUqY7`,
	"flip": `capabilities_flip__+1E5v`
};
export default ___CSS_LOADER_EXPORT___;
